export default function MSFPreRide() {
  return (
    <div>
    
    <img src='/Assets/TechTips/Service Tire MSF T-CLOCS_Inspection Check list.jpg' alt="MSF T-CLOCS Inspection Check List" />  </div>
  );
}
